let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hvz65")).then(() => parcelRequire('4f0Oq'));